import identityConfig from '../../../../config/identity';
import get from 'lodash/get';

export default function chartbeat(context) {
  const siteConfig = identityConfig;
  if (siteConfig === undefined) {
    return '';
  }
  let sections = '';
  let author = '';
  let title = '';
  if (context.type === 'post') {
    sections = get(context, 'postData.categories[0].name', '');
    author = get(context, 'postData.author.name', '');
    title = get(context, 'postData.title', '');
  } else if (context.type === 'homepage') {
    title = 'Homepage';
  } else if (context.type === 'micYearPage') {
    sections = 'Mic Year Page';
    title = get(context, 'micYearPageData.year', '');
  } else if (context.type === 'micSectorPage') {
    sections = 'Mic Sector Page';
    title = get(context, 'micYearPageData.year', '');
  } else if (context.type === 'videoIndexPage') {
    title = 'Video Index Page';
  } else if (context.type === 'videoPage') {
    sections = 'Video';
    title = get(context, 'videoPageData.data.title', '');
  } else if (context.type === 'category') {
    sections = 'Category';
    title = get(context, 'categoryPageData.data.title', '');
  } else if (context.type === 'giftGuidePage') {
    sections = 'Gift Guide';
    let year = 2018;
    if (get(context, 'giftGuideData.year') === 1) {
      year = 2017;
    }
    title = `Gift Guide ${year}`;
  }

  title = title.replace("'", '');
  author = author.replace("'", '');
  sections = sections.replace("'", '');
  return `
    <script type='text/javascript'>
    (function() {
        /** CONFIGURATION START **/
        var _sf_async_config = window._sf_async_config = (window._sf_async_config || {});

        _sf_async_config.uid = 2768;
        _sf_async_config.domain = 'fastcompany.com';
        _sf_async_config.flickerControl = false;
        _sf_async_config.useCanonical = true;
        _sf_async_config.useCanonicalDomain = true;
        _sf_async_config.sections = '${sections}';
        _sf_async_config.authors = '${author}';
        _sf_async_config.title = '${title}';
        /** CONFIGURATION END **/
        function loadChartbeat() {
            var e = document.createElement('script');
            var n = document.getElementsByTagName('script')[0];
            e.type = 'text/javascript';
            e.async = true;
            e.src = '//static.chartbeat.com/js/chartbeat.js';
            n.parentNode.insertBefore(e, n);
        }
        var oldonload = window.onload;
        window.onload = (typeof window.onload != 'function') ? loadChartbeat : function() { oldonload(); loadChartbeat(); };
     })();
</script>
  `;
}
